import { Box } from '@material-ui/core';
import Item from 'containers/ContactsUtilsPage/Item';
import message from 'containers/ContactsUtilsPage/messages';
import {
  SectionWrapper,
  StyledSectionTitle,
} from 'containers/ContactsUtilsPage/styles';
import { SectionsProps } from 'containers/ContactsUtilsPage/types';
import get from 'lodash/get';
import React from 'react';
import { useIntl } from 'react-intl';

const NUMEROS_ASSISTANCE = 'numeros_assistance';
const RESEAU_NATIONAL = 'reseau_national';
const HEALTH_NUMBER = '0522957591';

const Section = ({ type, body }: SectionsProps) => {
  const { formatMessage } = useIntl();

  return (
    <Box my={2}>
      <SectionWrapper>
        <StyledSectionTitle>
          {formatMessage(get(message, type))}
        </StyledSectionTitle>
        <div>
          {body
            ?.filter(
              ({ param }) =>
                param !== RESEAU_NATIONAL && param !== HEALTH_NUMBER,
            )
            .map((item, index) => (
              <Item
                {...item}
                title={
                  get(message, item.title)
                    ? formatMessage(get(message, item.title))
                    : item.title
                }
                key={index}
                phoneText={formatMessage(message.phone, {
                  number: item.param,
                })}
                icon={
                  type === NUMEROS_ASSISTANCE
                    ? (item.key as string)
                    : item.icon!
                }
              />
            ))}
        </div>
      </SectionWrapper>
    </Box>
  );
};

export default Section;
